module.exports = "pegasus_template/assets/email1-column-13.png";